import { Button } from '@mui/material';
import { useEffect, useState } from 'react';

import { VoiceDialog } from 'entities/voice';

import { Country, Voices } from 'shared/api';

type Props = {
  disabled?: boolean;
  onSubmit: (data: Partial<Voices>) => void;
  isSuccess: boolean;
  isLoading: boolean;
  countries: Country[];
};

export const CreateVoice = ({ disabled = false, onSubmit, isSuccess, isLoading, countries }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isSuccess) setIsOpen(false);
  }, [isSuccess]);

  return (
    <>
      <Button variant="contained" onClick={() => setIsOpen(true)} sx={{ alignSelf: 'end' }} disabled={disabled}>
        Add voice
      </Button>
      <VoiceDialog
        title="Add voice"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={onSubmit}
        isLoading={isLoading}
        countries={countries}
      />
    </>
  );
};
